<template>
    <flex-element
        v-if="isVisible"
        :element-type="elementType"
        tag="article"
    >
        <div v-if="values && values.length > 0">
            <div v-if="toggleEnabled" class="f-flex f-items-center mob:f-hidden f-flex-row f-flex-wrap f-justify-end f-mt-0 f--mb-1 f-relative f-w-1/1 f-z-1 mob:f-hidden">
                <button
                    v-if="!facetListValuesVisible"
                    class="f-text-0.75 f-font-black f-px-0.5 f-relative f-text-center"
                    role="presentation"
                    @click.prevent="expand"
                >
                    <font-awesome-icon class="fc-keywords__icon" :icon="['fal', 'plus']" />
                </button>
                <button
                    v-if="facetListValuesVisible"
                    class="f-text-0.75 f-font-black f-px-0.5 f-relative f-text-center"
                    role="presentation"
                    @click.prevent="collapse"
                >
                    <font-awesome-icon class="fc-keywords__icon" :icon="['fal', 'minus']" />
                </button>
            </div>

            <button v-if="toggleEnabled" @click.prevent="toggle">
                <a-heading
                    tag-default="div"
                    v-bind="element(1)"
                    class-default-inline="f-font-default f-text-0.9375 f-font-semibold f-leading-tight f-text-black f-uppercase f-pb-1 f-block mob:f-hidden"
                    class="f-relative f-z-1"
                    @element-updated="elementUpdated"
                >
                    FACET NAME
                </a-heading>
            </button>

            <a-heading
                v-if="!toggleEnabled"
                tag-default="h3"
                v-bind="element(1)"
                class-default-inline="f-font-default f-text-0.9375 f-font-semibold f-leading-tight f-text-black f-uppercase f-pb-1 f-block mob:f-hidden"
                @element-updated="elementUpdated"
            >
                FACET NAME
            </a-heading>

            <facet-list-group
                v-show="facetListValuesVisible"
                ref="facetList"
                :name="facetPropertyName"
                :values="values"
                v-bind="element(2)"
                class-default-inline="f-block mob:f-hidden f-overflow-auto"
                @element-updated="elementUpdated"
                @show-all="facetPopulated"
                @facet-selected="facetSelected"
            />
            <a-button
                v-if="seeAllVisible"
                ref="seeAll"
                v-bind="element(4)"
                type="button"
                class-default-inline="f-block mob:f-hidden f-cursor-pointer"
                @element-updated="elementUpdated"
                @click.native="showAll"
            >
                See all
            </a-button>
            <facet-dropdown
                :name="facetPropertyName"
                :title="heading"
                :values="values"
                v-bind="element(3)"
                class-default-inline="f-hidden mob:f-block"
                @element-updated="elementUpdated"
                @facet-selected="facetSelected"
            />
        </div>
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';
import listenOnRootMixin from '@/mixins/listen-on-root';

const CUSTOM_ATTR_NAME = 'search-facet';
const CUSTOM_TOGGLE_ATTR_NAME = 'search-facet-value-toggle';

export default {
    mixins: [baseOrganism, listenOnRootMixin],

    data() {
        return {
            facetPropertyName: '',
            values: [],
            isVisible: false,
            isSelected: false,
            heading: '',
            seeAllVisible: false,
            facetListValuesVisible: false,
            toggleEnabled: false,
        };
    },

    watch: {
        seeAllVisible(isVisible) {
            if (isVisible) this.refreshSeeAll();
        },
    },

    mounted() {
        this.listenOnRoot('flex::collection::search-data-facets', this.onQueryUpdate);
        this.facetPropertyName = this.getElementData(CUSTOM_ATTR_NAME);
        const urlParams = new URLSearchParams(window.location.search);
        this.isSelected = !!urlParams.get(this.facetPropertyName);
        this.heading = this.element(1) ? this.element(1).singleLineText : this.facetPropertyName;
        this.toggleEnabled = this.getElementData(CUSTOM_TOGGLE_ATTR_NAME) || false;
        this.facetListValuesVisible = !this.toggleEnabled;
    },

    methods: {
        onQueryUpdate(val) {
            this.refreshSeeAll();
            const facet = val.find(i => i.name === this.facetPropertyName);
            if (facet && facet.values && facet.values.length > 0) {
                this.values = facet.values;
                this.isVisible = true;
            } else if (!this.isPageEditor && !this.isTemplateEditor && !this.isComponentEditor) {
                this.isVisible = false;
                this.values = [];
            } else {
                this.values = [];
                this.isVisible = true;
            }
        },

        showAll(e) {
            const facetList = this.$refs.facetList;
            if (facetList) {
                e.target.parentNode.className += ' f-hidden';
                facetList.$el.className = facetList.$el.className.replace('f-h-5', '');
            }
        },

        facetPopulated(visible) {
            this.seeAllVisible = visible;
        },

        facetSelected(value) {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get(this.facetPropertyName) || urlParams.get(this.facetPropertyName) === '') {
                urlParams.set(this.facetPropertyName, value);
            } else {
                urlParams.append(this.facetPropertyName, value);
            }
            if (this.eventPage) {
                window.location.href = `${ this.eventPage }?${ urlParams }`;
            } else {
                window.history.replaceState({}, '', `${ window.location.pathname }?${ urlParams }`);
                this.emitOnRoot('flex::collection::query-refresh');
            }
        },

        refreshSeeAll() {
            if (this.$refs.seeAll && this.$refs.facetList) {
                this.$refs.seeAll.$el.className = this.$refs.seeAll.$el.className.replace(' f-hidden', '');
                this.$refs.facetList.$el.className += ' f-h-5';
            }
        },

        collapse() {
            this.facetListValuesVisible = false;
        },

        expand() {
            this.facetListValuesVisible = true;
        },

        toggle() {
            if (this.toggleEnabled) {
                this.facetListValuesVisible = !this.facetListValuesVisible;
            }
        },
    },
};
</script>
